// extracted by mini-css-extract-plugin
export default {"footer_modal_import_container":"ModalImport_footer_modal_import_container__rRtal","upload":"ModalImport_upload__s+uM-","table_select":"ModalImport_table_select__JBOov"};